import { render } from "./AgeVerificationSettings.vue?vue&type=template&id=82d06048&scoped=true"
import script from "./AgeVerificationSettings.vue?vue&type=script&lang=js"
export * from "./AgeVerificationSettings.vue?vue&type=script&lang=js"

import "./AgeVerificationSettings.vue?vue&type=style&index=0&id=82d06048&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82d06048"]])

export default __exports__